/* eslint-disable no-console */
import { getRevertReason } from './eth-revert-reason';
import { GAS_MARGIN, PERCENT, PUBLIC_NETWORK } from './constants';
import { BigNumber } from '@ethersproject/bignumber';

export const TX_TYPE = {
  // This means we are in the process of approving a token
  APPROVE_TOKEN: 'APPROVE_TOKEN',
  DEFAULT: 'DEFAULT',
};

export const TX_STATUS = {
  // User needs to click confirm tx (for ex via metamask popup)
  AWAITING_USER_ACTION: 'AWAITING_USER_ACTION',
  // Waiting for transaction to go through
  PENDING: 'PENDING',
  // Success
  CONFIRMED: 'CONFIRMED',
  // ERROR
  FAILED: 'FAILED',
};

export const ERROR_STATES = {
  CONFIRM_REJECTED: 'MetaMask Tx Signature: User denied transaction signature.',
  GAS_EXCEEDED: 'gas required exceeds allowance (8000029) or always failing transaction',
};

// DEPRECATED (only used on dapp right now)
// TODO remove
export const getTxStatusString = (
  txStatus: string,
  txMeta: { transactionHash: any }
): string | null => {
  if (!txMeta || !txStatus) return null;
  const { transactionHash } = txMeta;
  if (txStatus === TX_STATUS.AWAITING_USER_ACTION) return `awaiting user action`;
  if (txStatus === TX_STATUS.PENDING) return `pending tx: ${transactionHash}`;
  if (txStatus === TX_STATUS.CONFIRMED) return `confirmed tx: ${transactionHash}`;
  if (txStatus === TX_STATUS.FAILED) return `failed tx: ${transactionHash}`;
  return null;
};

export async function logRevert({
  contract,
  action,
  args,
  library,
  account,
}): Promise<string | null> {
  try {
    if (!contract || !contract.interface) return null;
    const data = contract?.interface.encodeFunctionData(action, args);

    const tx = {
      to: contract.address,
      data: data,
      from: account,
    };
    console.log(tx);

    return await getRevertReason(null, tx, PUBLIC_NETWORK, 'latest', library);
  } catch (err) {
    console.error('revert error', err);
    return null;
  }
}

export function calculateGasMargin(value: BigNumber) {
  const offset = value.mul(GAS_MARGIN).div(PERCENT);
  return value.add(offset);
}
